import { render, staticRenderFns } from "./AmlApprovalNotifier.vue?vue&type=template&id=02cf5a86"
import script from "./AmlApprovalNotifier.vue?vue&type=script&lang=js"
export * from "./AmlApprovalNotifier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports